import styled from 'styled-components';

const TruncatedText = styled.span`
    display: inline-block;
    text-overflow: ellipsis;
    width: 150px;
    overflow: hidden;
    white-space: nowrap;
`;

export default TruncatedText;
